import { UrlParser } from "@authory-packages/core";

const forceFindContentDomains = ["youtube.com"];

export const forceUseFindContent = (url: string) => {
    let forceContentEndpoint = false;

    try {
        const domain = UrlParser.extractDomain(url);

        if (domain && forceFindContentDomains.includes(domain)) forceContentEndpoint = true;
    } catch {}

    return forceContentEndpoint;
};
